import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  infoMerch: [],
  infoDetail:{},
  total: 0
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_LIST_INFO:
        draft.infoMerch = action.payload.data;
        draft.total = action.payload.total;
        break;
      case Types.GET_INFO_DETAIL:
        draft.infoDetail = action.detail_info;
        break;
      default:
        return state;
    }
  })
}

